export default (params) => ({
  trigger: {
    name: 'overarching_product_line.click_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        method: 'link',
        sub_feature: null,
      },
    },
    nonInt: false,
  },
});
